import React from 'react';

export const Error500 = ({ title,  description1 }) => {  
  return (
    <div style={{ backgroundColor: '#f2f2f2', padding: '20px', borderRadius: '10px', marginBottom: '30px' }}>
      <div style={{ textAlign: 'center' }}>
        <i className={`dx-icon dx-icon-lock`} style={{ fontSize: '70px', color: '#f44336', borderRadius: '50%', backgroundColor: 'white', padding: '20px' }}></i>
        <h3 style={{ marginTop: '15px', color:'#f44336', marginBottom: '10px' }}> {title ? title : 'Acceso denegado'}</h3>
      </div>
      <div style={{ marginTop: '10px' }}><p>{description1}</p></div>      
    </div>
  );
};